import { Link, Path } from "@/router";
import classNames from "classnames";
import type { NavigationItemProps } from "./types";

export default function OpenNavigationItem<P extends Path>({
  active = false,
  linkClass,
  link,
  label,
  icon,
  trailingIcon,
  onClick,
  menuTriggerProps
}: NavigationItemProps<P>) {
  const className = classNames(
    "w-full rounded-lg",
    {
      "hover:!bg-extended-pgadarknavy-brand-color-bright": !active,
      "bg-sys-brand-surface text-sys-brand-primary": active
    },
    linkClass
  );

  const content = (
    <div className={classNames("flex py-4 pl-4 space-x-3 items-center", trailingIcon ? "pr-3" : "pr-6")}>
      <div className="leading-3">{icon}</div>
      <div className="flex-1 text-label-large">{label}</div>
      {trailingIcon && <div className="leading-3">{trailingIcon}</div>}
    </div>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={classNames(className, "text-left cursor-pointer")}
        {...menuTriggerProps}
      >
        {content}
      </button>
    );
  }

  return (
    <Link {...link} className={className} {...menuTriggerProps}>
      {content}
    </Link>
  );
}
